import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-personas-booking',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './booking.component.html',
  styleUrl: './booking.component.scss'
})
export class PersonasBookingComponent {

}
